import Meaning from "./Meaning";

const returnHint = (hint) => {
    // console.log(hint);
    if(hint){
        return(
            <Meaning
                content={hint}
                word="(hint)"
            />
        )
    }
    else{
        return(
            <>
            </>
        )
    }
}

export default returnHint;